@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(-1_063_027_909)
internal val Res.string.document_history_empty: StringResource by lazy {
      StringResource("string:document_history_empty", "document_history_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15829, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16017, 90),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15545, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14737, 82),
      ))
    }

@delegate:ResourceContentHash(1_193_786_635)
internal val Res.string.document_history_generated_at: StringResource by lazy {
      StringResource("string:document_history_generated_at", "document_history_generated_at", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15920, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16108, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15628, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14820, 61),
      ))
    }

@delegate:ResourceContentHash(-798_518_239)
internal val Res.string.document_history_title: StringResource by lazy {
      StringResource("string:document_history_title", "document_history_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15982, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16170, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15686, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14882, 54),
      ))
    }

@delegate:ResourceContentHash(-2_075_435_954)
internal val Res.string.document_type_lightning: StringResource by lazy {
      StringResource("string:document_type_lightning", "document_type_lightning", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16045, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16233, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15749, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14937, 71),
      ))
    }

@delegate:ResourceContentHash(2_075_710_520)
internal val Res.string.document_type_nsg: StringResource by lazy {
      StringResource("string:document_type_nsg", "document_type_nsg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16117, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16301, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15821, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15009, 45),
      ))
    }

@delegate:ResourceContentHash(277_783_017)
internal val Res.string.documents_all_years: StringResource by lazy {
      StringResource("string:documents_all_years", "documents_all_years", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16163, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16347, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15867, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15055, 31),
      ))
    }

@delegate:ResourceContentHash(-477_783_616)
internal val Res.string.documents_badge: StringResource by lazy {
      StringResource("string:documents_badge", "documents_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16199, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16383, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15903, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15087, 35),
      ))
    }

@delegate:ResourceContentHash(864_502_314)
internal val Res.string.documents_count: StringResource by lazy {
      StringResource("string:documents_count", "documents_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16235, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16419, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15939, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15123, 47),
      ))
    }

@delegate:ResourceContentHash(1_624_708_377)
internal val Res.string.documents_last: StringResource by lazy {
      StringResource("string:documents_last", "documents_last", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16283, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16467, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15987, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15171, 38),
      ))
    }

@delegate:ResourceContentHash(-470_114_949)
internal val Res.string.documents_new_button: StringResource by lazy {
      StringResource("string:documents_new_button", "documents_new_button", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16326, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16510, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16030, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15210, 56),
      ))
    }

@delegate:ResourceContentHash(-772_467_065)
internal val Res.string.documents_no_document: StringResource by lazy {
      StringResource("string:documents_no_document", "documents_no_document", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16387, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16571, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16091, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15267, 45),
      ))
    }

@delegate:ResourceContentHash(-1_207_801_534)
internal val Res.string.documents_no_site: StringResource by lazy {
      StringResource("string:documents_no_site", "documents_no_site", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16441, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16621, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16145, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15313, 45),
      ))
    }

@delegate:ResourceContentHash(-1_010_863_648)
internal val Res.string.documents_open: StringResource by lazy {
      StringResource("string:documents_open", "documents_open", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16507, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16671, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16203, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15359, 30),
      ))
    }

@delegate:ResourceContentHash(-1_608_843_181)
internal val Res.string.documents_search_hint: StringResource by lazy {
      StringResource("string:documents_search_hint", "documents_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16538, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16702, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16234, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15390, 57),
      ))
    }

@delegate:ResourceContentHash(1_823_644_515)
internal val Res.string.documents_show_more: StringResource by lazy {
      StringResource("string:documents_show_more", "documents_show_more", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16596, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16768, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16296, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15448, 63),
      ))
    }

@delegate:ResourceContentHash(1_585_662_251)
internal val Res.string.documents_unknown_error: StringResource by lazy {
      StringResource("string:documents_unknown_error", "documents_unknown_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16664, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16836, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16364, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15512, 51),
      ))
    }

@delegate:ResourceContentHash(1_642_335_516)
internal val Res.string.documents_unnamed_site: StringResource by lazy {
      StringResource("string:documents_unnamed_site", "documents_unnamed_site", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16720, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16888, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16420, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15564, 46),
      ))
    }

@delegate:ResourceContentHash(720_080_296)
internal val Res.string.download_certificate: StringResource by lazy {
      StringResource("string:download_certificate", "download_certificate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16775, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16939, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16471, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15611, 56),
      ))
    }

@delegate:ResourceContentHash(-1_237_888_199)
internal val Res.string.dreamborn_url_or_id_text: StringResource by lazy {
      StringResource("string:dreamborn_url_or_id_text", "dreamborn_url_or_id_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16832, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17004, 100),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16524, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15668, 88),
      ))
    }

@delegate:ResourceContentHash(1_210_942_803)
internal val Res.string.dreamborn_url_or_id_title: StringResource by lazy {
      StringResource("string:dreamborn_url_or_id_title", "dreamborn_url_or_id_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16917, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17105, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16621, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15757, 57),
      ))
    }

@delegate:ResourceContentHash(-558_005_161)
internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16975, 20),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17159, 20),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16679, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15815, 20),
      ))
    }

@delegate:ResourceContentHash(-2_110_362_140)
internal val Res.string.error_loading_check_connection: StringResource by lazy {
      StringResource("string:error_loading_check_connection", "error_loading_check_connection", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16996, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17180, 102),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16700, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15836, 86),
      ))
    }

@delegate:ResourceContentHash(-296_269_934)
internal val Res.string.error_message_title: StringResource by lazy {
      StringResource("string:error_message_title", "error_message_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17087, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17283, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16799, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15923, 67),
      ))
    }

@delegate:ResourceContentHash(-69_136_367)
internal val Res.string.estimate_choose_a_date: StringResource by lazy {
      StringResource("string:estimate_choose_a_date", "estimate_choose_a_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17163, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17343, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16863, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15991, 50),
      ))
    }

@delegate:ResourceContentHash(2_070_313_127)
internal val Res.string.estimate_created_on: StringResource by lazy {
      StringResource("string:estimate_created_on", "estimate_created_on", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17218, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17402, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16918, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16042, 47),
      ))
    }

@delegate:ResourceContentHash(-921_306_524)
internal val Res.string.estimate_email: StringResource by lazy {
      StringResource("string:estimate_email", "estimate_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17266, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17450, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 16966, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16090, 42),
      ))
    }

@delegate:ResourceContentHash(-1_119_850_156)
internal val Res.string.estimate_enabled: StringResource by lazy {
      StringResource("string:estimate_enabled", "estimate_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17558, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17710, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17226, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16330, 36),
      ))
    }

@delegate:ResourceContentHash(1_261_778_068)
internal val Res.string.estimate_enabled_explanation: StringResource by lazy {
      StringResource("string:estimate_enabled_explanation", "estimate_enabled_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17333, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17493, 88),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17009, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16133, 72),
      ))
    }

@delegate:ResourceContentHash(1_580_576_555)
internal val Res.string.estimate_enabled_label: StringResource by lazy {
      StringResource("string:estimate_enabled_label", "estimate_enabled_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17430, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17582, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17098, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16206, 42),
      ))
    }

@delegate:ResourceContentHash(150_250_621)
internal val Res.string.estimate_enabled_off: StringResource by lazy {
      StringResource("string:estimate_enabled_off", "estimate_enabled_off", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17473, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17625, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17141, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16249, 40),
      ))
    }

@delegate:ResourceContentHash(1_580_576_555)
internal val Res.string.estimate_enabled_on: StringResource by lazy {
      StringResource("string:estimate_enabled_on", "estimate_enabled_on", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17518, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17670, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17186, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16290, 39),
      ))
    }

@delegate:ResourceContentHash(-467_814_029)
internal val Res.string.estimate_existing_probes_count: StringResource by lazy {
      StringResource("string:estimate_existing_probes_count", "estimate_existing_probes_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17599, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17751, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17267, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16367, 74),
      ))
    }

@delegate:ResourceContentHash(-316_682_056)
internal val Res.string.estimate_is_external_contract: StringResource by lazy {
      StringResource("string:estimate_is_external_contract", "estimate_is_external_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17868, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18024, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17540, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16628, 77),
      ))
    }

@delegate:ResourceContentHash(664_925_036)
internal val Res.string.estimate_is_external_contract_explanation: StringResource by lazy {
      StringResource("string:estimate_is_external_contract_explanation", "estimate_is_external_contract_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17674, 193),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17826, 197),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17342, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16442, 185),
      ))
    }

@delegate:ResourceContentHash(787_959_120)
internal val Res.string.estimate_issue_external_subscription: StringResource by lazy {
      StringResource("string:estimate_issue_external_subscription", "estimate_issue_external_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17942, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18098, 100),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17610, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16706, 104),
      ))
    }

@delegate:ResourceContentHash(-343_520_584)
internal val Res.string.estimate_issue_probe_app: StringResource by lazy {
      StringResource("string:estimate_issue_probe_app", "estimate_issue_probe_app", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18051, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18199, 88),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17715, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16811, 76),
      ))
    }

@delegate:ResourceContentHash(-1_320_667_780)
internal val Res.string.estimate_issue_probe_demo: StringResource by lazy {
      StringResource("string:estimate_issue_probe_demo", "estimate_issue_probe_demo", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18132, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18288, 109),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17796, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16888, 97),
      ))
    }

@delegate:ResourceContentHash(1_746_457_599)
internal val Res.string.estimate_issue_probe_end: StringResource by lazy {
      StringResource("string:estimate_issue_probe_end", "estimate_issue_probe_end", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18246, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18398, 104),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 17906, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16986, 96),
      ))
    }

@delegate:ResourceContentHash(-1_002_966_143)
internal val Res.string.estimate_issue_probe_expired: StringResource by lazy {
      StringResource("string:estimate_issue_probe_expired", "estimate_issue_probe_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18359, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18503, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18015, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17083, 64),
      ))
    }

@delegate:ResourceContentHash(-191_418_569)
internal val Res.string.estimate_issue_probe_owner: StringResource by lazy {
      StringResource("string:estimate_issue_probe_owner", "estimate_issue_probe_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18424, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18568, 86),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18076, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17148, 82),
      ))
    }

@delegate:ResourceContentHash(798_989_480)
internal val Res.string.estimate_issue_subscription_quantity: StringResource by lazy {
      StringResource("string:estimate_issue_subscription_quantity", "estimate_issue_subscription_quantity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18503, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18655, 124),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18155, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17231, 112),
      ))
    }

@delegate:ResourceContentHash(-1_424_280_637)
internal val Res.string.estimate_issue_unpaid_active_probes: StringResource by lazy {
      StringResource("string:estimate_issue_unpaid_active_probes", "estimate_issue_unpaid_active_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18624, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18780, 95),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18272, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17344, 87),
      ))
    }

@delegate:ResourceContentHash(1_100_872_669)
internal val Res.string.estimate_next_tier_hint: StringResource by lazy {
      StringResource("string:estimate_next_tier_hint", "estimate_next_tier_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18708, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18876, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18360, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17432, 71),
      ))
    }

@delegate:ResourceContentHash(1_984_474_900)
internal val Res.string.estimate_no_email_set_text: StringResource by lazy {
      StringResource("string:estimate_no_email_set_text", "estimate_no_email_set_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18780, 198),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18948, 178),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18432, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17504, 158),
      ))
    }

@delegate:ResourceContentHash(2_032_970_773)
internal val Res.string.estimate_no_email_set_title: StringResource by lazy {
      StringResource("string:estimate_no_email_set_title", "estimate_no_email_set_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18979, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19127, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18619, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17663, 55),
      ))
    }

@delegate:ResourceContentHash(917_967_504)
internal val Res.string.estimate_payment_demo: StringResource by lazy {
      StringResource("string:estimate_payment_demo", "estimate_payment_demo", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19055, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19183, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18679, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17719, 49),
      ))
    }

@delegate:ResourceContentHash(449_209_455)
internal val Res.string.estimate_payment_external: StringResource by lazy {
      StringResource("string:estimate_payment_external", "estimate_payment_external", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19101, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19237, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18729, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17769, 69),
      ))
    }

@delegate:ResourceContentHash(1_593_562_242)
internal val Res.string.estimate_payment_stripe: StringResource by lazy {
      StringResource("string:estimate_payment_stripe", "estimate_payment_stripe", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19167, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19307, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18799, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17839, 71),
      ))
    }

@delegate:ResourceContentHash(-842_385_779)
internal val Res.string.estimate_probe_default_name: StringResource by lazy {
      StringResource("string:estimate_probe_default_name", "estimate_probe_default_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19235, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19379, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18871, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17911, 51),
      ))
    }

@delegate:ResourceContentHash(-1_499_431_560)
internal val Res.string.estimate_probe_inactive: StringResource by lazy {
      StringResource("string:estimate_probe_inactive", "estimate_probe_inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19287, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19431, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18923, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17963, 43),
      ))
    }

@delegate:ResourceContentHash(930_447_309)
internal val Res.string.estimate_probes_count_label: StringResource by lazy {
      StringResource("string:estimate_probes_count_label", "estimate_probes_count_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19331, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19475, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 18967, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18007, 47),
      ))
    }

@delegate:ResourceContentHash(1_614_360_864)
internal val Res.string.estimate_ref: StringResource by lazy {
      StringResource("string:estimate_ref", "estimate_ref", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19379, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19523, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19015, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18055, 32),
      ))
    }

@delegate:ResourceContentHash(-666_434_160)
internal val Res.string.estimate_select_the_probes: StringResource by lazy {
      StringResource("string:estimate_select_the_probes", "estimate_select_the_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19412, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19560, 78),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19048, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18088, 70),
      ))
    }

@delegate:ResourceContentHash(972_058_073)
internal val Res.string.estimate_selected_end_date: StringResource by lazy {
      StringResource("string:estimate_selected_end_date", "estimate_selected_end_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19491, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19639, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19123, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18159, 62),
      ))
    }

@delegate:ResourceContentHash(1_399_668_761)
internal val Res.string.estimate_side_effect_activated_now: StringResource by lazy {
      StringResource("string:estimate_side_effect_activated_now", "estimate_side_effect_activated_now", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19574, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19694, 158),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19198, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18222, 126),
      ))
    }

@delegate:ResourceContentHash(-1_993_784_267)
internal val Res.string.estimate_side_effect_activated_with_deadline: StringResource by lazy {
      StringResource("string:estimate_side_effect_activated_with_deadline", "estimate_side_effect_activated_with_deadline", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19705, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19853, 156),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19325, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18349, 164),
      ))
    }

@delegate:ResourceContentHash(779_129_325)
internal val Res.string.estimate_side_effect_deactivated: StringResource by lazy {
      StringResource("string:estimate_side_effect_deactivated", "estimate_side_effect_deactivated", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19870, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20010, 112),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19482, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18514, 100),
      ))
    }

@delegate:ResourceContentHash(264_626_735)
internal val Res.string.estimate_status_active: StringResource by lazy {
      StringResource("string:estimate_status_active", "estimate_status_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19967, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20123, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19579, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18615, 38),
      ))
    }

@delegate:ResourceContentHash(-2_108_473_618)
internal val Res.string.estimate_status_demo: StringResource by lazy {
      StringResource("string:estimate_status_demo", "estimate_status_demo", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20063, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20219, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19675, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18707, 36),
      ))
    }

@delegate:ResourceContentHash(-1_044_741_507)
internal val Res.string.estimate_status_demo_expired: StringResource by lazy {
      StringResource("string:estimate_status_demo_expired", "estimate_status_demo_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20006, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20162, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19618, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18654, 52),
      ))
    }

@delegate:ResourceContentHash(-931_347_923)
internal val Res.string.estimate_status_empty: StringResource by lazy {
      StringResource("string:estimate_status_empty", "estimate_status_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20100, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20256, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19712, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18744, 37),
      ))
    }

@delegate:ResourceContentHash(962_694_727)
internal val Res.string.estimate_status_ended: StringResource by lazy {
      StringResource("string:estimate_status_ended", "estimate_status_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20138, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20294, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19750, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18782, 53),
      ))
    }

@delegate:ResourceContentHash(632_630_057)
internal val Res.string.estimate_status_expired: StringResource by lazy {
      StringResource("string:estimate_status_expired", "estimate_status_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20200, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20352, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19808, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18836, 43),
      ))
    }

@delegate:ResourceContentHash(-751_979_930)
internal val Res.string.estimate_status_external_active: StringResource by lazy {
      StringResource("string:estimate_status_external_active", "estimate_status_external_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20244, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20396, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19852, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18880, 75),
      ))
    }

@delegate:ResourceContentHash(1_571_610_782)
internal val Res.string.estimate_status_external_contract: StringResource by lazy {
      StringResource("string:estimate_status_external_contract", "estimate_status_external_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20320, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20468, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19928, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18956, 65),
      ))
    }

@delegate:ResourceContentHash(-1_864_528_927)
internal val Res.string.estimate_status_external_disabled: StringResource by lazy {
      StringResource("string:estimate_status_external_disabled", "estimate_status_external_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20386, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20530, 81),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 19994, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19022, 81),
      ))
    }

@delegate:ResourceContentHash(-780_909_861)
internal val Res.string.estimate_status_external_expired: StringResource by lazy {
      StringResource("string:estimate_status_external_expired", "estimate_status_external_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20472, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20612, 76),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20076, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19104, 80),
      ))
    }

@delegate:ResourceContentHash(-329_108_609)
internal val Res.string.estimate_status_external_partial: StringResource by lazy {
      StringResource("string:estimate_status_external_partial", "estimate_status_external_partial", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20553, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20689, 76),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20157, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19185, 80),
      ))
    }

@delegate:ResourceContentHash(-1_532_846_413)
internal val Res.string.estimate_status_payment_issue: StringResource by lazy {
      StringResource("string:estimate_status_payment_issue", "estimate_status_payment_issue", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20630, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20766, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20234, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19266, 57),
      ))
    }

@delegate:ResourceContentHash(-1_628_131_690)
internal val Res.string.estimate_status_pending_payment: StringResource by lazy {
      StringResource("string:estimate_status_pending_payment", "estimate_status_pending_payment", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20692, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20832, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20300, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19324, 59),
      ))
    }

@delegate:ResourceContentHash(1_683_277_057)
internal val Res.string.estimate_test_checkout_validate_text: StringResource by lazy {
      StringResource("string:estimate_test_checkout_validate_text", "estimate_test_checkout_validate_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20752, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20904, 164),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20364, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19384, 124),
      ))
    }

@delegate:ResourceContentHash(956_206_051)
internal val Res.string.estimate_test_checkout_validate_title: StringResource by lazy {
      StringResource("string:estimate_test_checkout_validate_title", "estimate_test_checkout_validate_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20873, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21069, 105),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20513, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19509, 77),
      ))
    }

@delegate:ResourceContentHash(1_314_784_965)
internal val Res.string.estimate_toggle_cancel: StringResource by lazy {
      StringResource("string:estimate_toggle_cancel", "estimate_toggle_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20959, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21175, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20599, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19587, 38),
      ))
    }

@delegate:ResourceContentHash(320_442_199)
internal val Res.string.estimate_toggle_confirm: StringResource by lazy {
      StringResource("string:estimate_toggle_confirm", "estimate_toggle_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21002, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21218, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20642, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19626, 43),
      ))
    }

@delegate:ResourceContentHash(-1_777_932_176)
internal val Res.string.estimate_toggle_disable_title: StringResource by lazy {
      StringResource("string:estimate_toggle_disable_title", "estimate_toggle_disable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21046, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21262, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20686, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19670, 73),
      ))
    }

@delegate:ResourceContentHash(548_233_044)
internal val Res.string.estimate_toggle_enable_title: StringResource by lazy {
      StringResource("string:estimate_toggle_enable_title", "estimate_toggle_enable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21124, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21332, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20760, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19744, 68),
      ))
    }

@delegate:ResourceContentHash(-675_466_383)
internal val Res.string.estimate_toggle_error: StringResource by lazy {
      StringResource("string:estimate_toggle_error", "estimate_toggle_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21197, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21393, 101),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20829, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19813, 101),
      ))
    }

@delegate:ResourceContentHash(-2_111_901_923)
internal val Res.string.estimate_toggle_readonly_demo: StringResource by lazy {
      StringResource("string:estimate_toggle_readonly_demo", "estimate_toggle_readonly_demo", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21303, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21495, 89),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 20935, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19915, 81),
      ))
    }

@delegate:ResourceContentHash(2_110_615_024)
internal val Res.string.estimate_toggle_readonly_stripe: StringResource by lazy {
      StringResource("string:estimate_toggle_readonly_stripe", "estimate_toggle_readonly_stripe", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21389, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21585, 103),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21017, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19997, 107),
      ))
    }

@delegate:ResourceContentHash(-163_875_867)
internal val Res.string.estimate_toggle_text: StringResource by lazy {
      StringResource("string:estimate_toggle_text", "estimate_toggle_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21501, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21689, 112),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21117, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20105, 104),
      ))
    }

@delegate:ResourceContentHash(1_272_084_307)
internal val Res.string.estimate_type: StringResource by lazy {
      StringResource("string:estimate_type", "estimate_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21714, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21902, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21334, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20310, 41),
      ))
    }

@delegate:ResourceContentHash(139_612_736)
internal val Res.string.estimate_type_skysentinel: StringResource by lazy {
      StringResource("string:estimate_type_skysentinel", "estimate_type_skysentinel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21614, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21802, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21234, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20210, 49),
      ))
    }

@delegate:ResourceContentHash(1_620_740_288)
internal val Res.string.estimate_type_strikeradar: StringResource by lazy {
      StringResource("string:estimate_type_strikeradar", "estimate_type_strikeradar", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21664, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21852, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21284, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20260, 49),
      ))
    }

@delegate:ResourceContentHash(-1_438_549_259)
internal val Res.string.estimate_use_end_date: StringResource by lazy {
      StringResource("string:estimate_use_end_date", "estimate_use_end_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21764, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21944, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21380, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20352, 61),
      ))
    }

@delegate:ResourceContentHash(1_200_338_998)
internal val Res.string.estimate_valid_until: StringResource by lazy {
      StringResource("string:estimate_valid_until", "estimate_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21838, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21998, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21446, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20414, 44),
      ))
    }

@delegate:ResourceContentHash(-400_053_861)
internal val Res.string.estimate_validate_done: StringResource by lazy {
      StringResource("string:estimate_validate_done", "estimate_validate_done", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21887, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22051, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21495, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20459, 38),
      ))
    }

@delegate:ResourceContentHash(-1_647_995_380)
internal val Res.string.estimate_validate_no_probes: StringResource by lazy {
      StringResource("string:estimate_validate_no_probes", "estimate_validate_no_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21926, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22094, 75),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21542, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20498, 71),
      ))
    }

@delegate:ResourceContentHash(445_032_498)
internal val Res.string.estimate_validate_payment: StringResource by lazy {
      StringResource("string:estimate_validate_payment", "estimate_validate_payment", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21998, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22170, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21614, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20570, 53),
      ))
    }

@delegate:ResourceContentHash(224_683_627)
internal val Res.string.estimate_validate_text: StringResource by lazy {
      StringResource("string:estimate_validate_text", "estimate_validate_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22056, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22236, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21668, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20624, 62),
      ))
    }

@delegate:ResourceContentHash(-531_076_257)
internal val Res.string.estimate_validate_title: StringResource by lazy {
      StringResource("string:estimate_validate_title", "estimate_validate_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22123, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22291, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21731, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20687, 59),
      ))
    }

@delegate:ResourceContentHash(615_723_361)
internal val Res.string.estimate_volume_discounts: StringResource by lazy {
      StringResource("string:estimate_volume_discounts", "estimate_volume_discounts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22191, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22351, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21799, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20747, 57),
      ))
    }

@delegate:ResourceContentHash(1_390_553_058)
internal val Res.string.estimates_button_create_new_radar_network: StringResource by lazy {
      StringResource("string:estimates_button_create_new_radar_network", "estimates_button_create_new_radar_network", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22257, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22405, 93),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21861, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20805, 105),
      ))
    }

@delegate:ResourceContentHash(1_146_239_992)
internal val Res.string.estimates_count: StringResource by lazy {
      StringResource("string:estimates_count", "estimates_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22371, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22499, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 21967, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20911, 55),
      ))
    }

@delegate:ResourceContentHash(292_679_478)
internal val Res.string.estimates_filter_all: StringResource by lazy {
      StringResource("string:estimates_filter_all", "estimates_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22431, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22551, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22027, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20967, 32),
      ))
    }

@delegate:ResourceContentHash(1_465_767_511)
internal val Res.string.estimates_filter_show_empty: StringResource by lazy {
      StringResource("string:estimates_filter_show_empty", "estimates_filter_show_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22468, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22588, 83),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22064, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21000, 83),
      ))
    }

@delegate:ResourceContentHash(-1_347_917_234)
internal val Res.string.estimates_list_empty: StringResource by lazy {
      StringResource("string:estimates_list_empty", "estimates_list_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22556, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22672, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22148, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21084, 72),
      ))
    }

@delegate:ResourceContentHash(-1_624_714_677)
internal val Res.string.estimates_no_match: StringResource by lazy {
      StringResource("string:estimates_no_match", "estimates_no_match", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22625, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22737, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22217, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21157, 66),
      ))
    }

@delegate:ResourceContentHash(-1_609_098_430)
internal val Res.string.estimates_search_hint: StringResource by lazy {
      StringResource("string:estimates_search_hint", "estimates_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22712, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22820, 113),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22300, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21224, 93),
      ))
    }

@delegate:ResourceContentHash(783_731_165)
internal val Res.string.filter_aeroguard: StringResource by lazy {
      StringResource("string:filter_aeroguard", "filter_aeroguard", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22834, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22934, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22422, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21318, 40),
      ))
    }

@delegate:ResourceContentHash(1_122_442_975)
internal val Res.string.filter_full_day: StringResource by lazy {
      StringResource("string:filter_full_day", "filter_full_day", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22875, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22975, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22463, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21359, 39),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("document_history_empty", Res.string.document_history_empty)
  map.put("document_history_generated_at", Res.string.document_history_generated_at)
  map.put("document_history_title", Res.string.document_history_title)
  map.put("document_type_lightning", Res.string.document_type_lightning)
  map.put("document_type_nsg", Res.string.document_type_nsg)
  map.put("documents_all_years", Res.string.documents_all_years)
  map.put("documents_badge", Res.string.documents_badge)
  map.put("documents_count", Res.string.documents_count)
  map.put("documents_last", Res.string.documents_last)
  map.put("documents_new_button", Res.string.documents_new_button)
  map.put("documents_no_document", Res.string.documents_no_document)
  map.put("documents_no_site", Res.string.documents_no_site)
  map.put("documents_open", Res.string.documents_open)
  map.put("documents_search_hint", Res.string.documents_search_hint)
  map.put("documents_show_more", Res.string.documents_show_more)
  map.put("documents_unknown_error", Res.string.documents_unknown_error)
  map.put("documents_unnamed_site", Res.string.documents_unnamed_site)
  map.put("download_certificate", Res.string.download_certificate)
  map.put("dreamborn_url_or_id_text", Res.string.dreamborn_url_or_id_text)
  map.put("dreamborn_url_or_id_title", Res.string.dreamborn_url_or_id_title)
  map.put("edit", Res.string.edit)
  map.put("error_loading_check_connection", Res.string.error_loading_check_connection)
  map.put("error_message_title", Res.string.error_message_title)
  map.put("estimate_choose_a_date", Res.string.estimate_choose_a_date)
  map.put("estimate_created_on", Res.string.estimate_created_on)
  map.put("estimate_email", Res.string.estimate_email)
  map.put("estimate_enabled", Res.string.estimate_enabled)
  map.put("estimate_enabled_explanation", Res.string.estimate_enabled_explanation)
  map.put("estimate_enabled_label", Res.string.estimate_enabled_label)
  map.put("estimate_enabled_off", Res.string.estimate_enabled_off)
  map.put("estimate_enabled_on", Res.string.estimate_enabled_on)
  map.put("estimate_existing_probes_count", Res.string.estimate_existing_probes_count)
  map.put("estimate_is_external_contract", Res.string.estimate_is_external_contract)
  map.put("estimate_is_external_contract_explanation", Res.string.estimate_is_external_contract_explanation)
  map.put("estimate_issue_external_subscription", Res.string.estimate_issue_external_subscription)
  map.put("estimate_issue_probe_app", Res.string.estimate_issue_probe_app)
  map.put("estimate_issue_probe_demo", Res.string.estimate_issue_probe_demo)
  map.put("estimate_issue_probe_end", Res.string.estimate_issue_probe_end)
  map.put("estimate_issue_probe_expired", Res.string.estimate_issue_probe_expired)
  map.put("estimate_issue_probe_owner", Res.string.estimate_issue_probe_owner)
  map.put("estimate_issue_subscription_quantity", Res.string.estimate_issue_subscription_quantity)
  map.put("estimate_issue_unpaid_active_probes", Res.string.estimate_issue_unpaid_active_probes)
  map.put("estimate_next_tier_hint", Res.string.estimate_next_tier_hint)
  map.put("estimate_no_email_set_text", Res.string.estimate_no_email_set_text)
  map.put("estimate_no_email_set_title", Res.string.estimate_no_email_set_title)
  map.put("estimate_payment_demo", Res.string.estimate_payment_demo)
  map.put("estimate_payment_external", Res.string.estimate_payment_external)
  map.put("estimate_payment_stripe", Res.string.estimate_payment_stripe)
  map.put("estimate_probe_default_name", Res.string.estimate_probe_default_name)
  map.put("estimate_probe_inactive", Res.string.estimate_probe_inactive)
  map.put("estimate_probes_count_label", Res.string.estimate_probes_count_label)
  map.put("estimate_ref", Res.string.estimate_ref)
  map.put("estimate_select_the_probes", Res.string.estimate_select_the_probes)
  map.put("estimate_selected_end_date", Res.string.estimate_selected_end_date)
  map.put("estimate_side_effect_activated_now", Res.string.estimate_side_effect_activated_now)
  map.put("estimate_side_effect_activated_with_deadline", Res.string.estimate_side_effect_activated_with_deadline)
  map.put("estimate_side_effect_deactivated", Res.string.estimate_side_effect_deactivated)
  map.put("estimate_status_active", Res.string.estimate_status_active)
  map.put("estimate_status_demo", Res.string.estimate_status_demo)
  map.put("estimate_status_demo_expired", Res.string.estimate_status_demo_expired)
  map.put("estimate_status_empty", Res.string.estimate_status_empty)
  map.put("estimate_status_ended", Res.string.estimate_status_ended)
  map.put("estimate_status_expired", Res.string.estimate_status_expired)
  map.put("estimate_status_external_active", Res.string.estimate_status_external_active)
  map.put("estimate_status_external_contract", Res.string.estimate_status_external_contract)
  map.put("estimate_status_external_disabled", Res.string.estimate_status_external_disabled)
  map.put("estimate_status_external_expired", Res.string.estimate_status_external_expired)
  map.put("estimate_status_external_partial", Res.string.estimate_status_external_partial)
  map.put("estimate_status_payment_issue", Res.string.estimate_status_payment_issue)
  map.put("estimate_status_pending_payment", Res.string.estimate_status_pending_payment)
  map.put("estimate_test_checkout_validate_text", Res.string.estimate_test_checkout_validate_text)
  map.put("estimate_test_checkout_validate_title", Res.string.estimate_test_checkout_validate_title)
  map.put("estimate_toggle_cancel", Res.string.estimate_toggle_cancel)
  map.put("estimate_toggle_confirm", Res.string.estimate_toggle_confirm)
  map.put("estimate_toggle_disable_title", Res.string.estimate_toggle_disable_title)
  map.put("estimate_toggle_enable_title", Res.string.estimate_toggle_enable_title)
  map.put("estimate_toggle_error", Res.string.estimate_toggle_error)
  map.put("estimate_toggle_readonly_demo", Res.string.estimate_toggle_readonly_demo)
  map.put("estimate_toggle_readonly_stripe", Res.string.estimate_toggle_readonly_stripe)
  map.put("estimate_toggle_text", Res.string.estimate_toggle_text)
  map.put("estimate_type", Res.string.estimate_type)
  map.put("estimate_type_skysentinel", Res.string.estimate_type_skysentinel)
  map.put("estimate_type_strikeradar", Res.string.estimate_type_strikeradar)
  map.put("estimate_use_end_date", Res.string.estimate_use_end_date)
  map.put("estimate_valid_until", Res.string.estimate_valid_until)
  map.put("estimate_validate_done", Res.string.estimate_validate_done)
  map.put("estimate_validate_no_probes", Res.string.estimate_validate_no_probes)
  map.put("estimate_validate_payment", Res.string.estimate_validate_payment)
  map.put("estimate_validate_text", Res.string.estimate_validate_text)
  map.put("estimate_validate_title", Res.string.estimate_validate_title)
  map.put("estimate_volume_discounts", Res.string.estimate_volume_discounts)
  map.put("estimates_button_create_new_radar_network", Res.string.estimates_button_create_new_radar_network)
  map.put("estimates_count", Res.string.estimates_count)
  map.put("estimates_filter_all", Res.string.estimates_filter_all)
  map.put("estimates_filter_show_empty", Res.string.estimates_filter_show_empty)
  map.put("estimates_list_empty", Res.string.estimates_list_empty)
  map.put("estimates_no_match", Res.string.estimates_no_match)
  map.put("estimates_search_hint", Res.string.estimates_search_hint)
  map.put("filter_aeroguard", Res.string.filter_aeroguard)
  map.put("filter_full_day", Res.string.filter_full_day)
}
